import React, { useEffect } from 'react'
import { useAppDispatch } from '../Hooks/useAppDispatch'
import { useAppSelector } from '../Hooks/useAppSelector'
import { removeToast, selectToastMsg } from '../Redux/ToastSlice'
import './Toast.css'
const Toast =()=> {

    const dispatch =  useAppDispatch()
    const toastMsg = useAppSelector<string>(selectToastMsg)
    const Toast_timeout = 3000

    useEffect(()=>{
        if(toastMsg.length!==0)
        setTimeout(()=>dispatch(removeToast()),Toast_timeout)
    },[toastMsg,dispatch])

  return (
    <div>
        {toastMsg && (
        <div className='tsds_toastContainer'>
            {toastMsg}
        </div>
      )}
    </div>
  )
}

export default Toast